module.exports = __webpack_public_path__ + "static/media/self-awareness-percentage.638e9cbe.png";